import axios from 'axios';
import { API_URL } from '../config';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: `${API_URL}`,
  headers: { 'Content-Type': 'application/json' }
});

// Add request interceptor to include JWT token in all requests
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export const permissionService = {
  grant: async (user_id, permission) => {
    const response = await api.post('/permissions/grant', { user_id, permission });
    return response.data;
  },
  get: async (user_id) => {
    const response = await api.get(`/permissions/${user_id}`);
    return response.data;
  }
};
